import React, {useState, useEffect} from 'react';
import './NewsCard.css'

const NewsCard = ({title, description, content, author, image, url, publishedAt}) => {

	const [hours, setHours] = useState('hr')

	

	
	useEffect(() => {
		function adjustPublicationTime() {
		let dateArticle = new Date(publishedAt);
		let dateNow = new Date()
		let hoursSince = (dateNow.getTime() - dateArticle.getTime()) /1000 / 60 / 60
		hoursSince = Math.round(hoursSince);
		if (hoursSince > 1) {
			return setHours('Less than 1hr ago') 
		} else {
			return setHours(hoursSince + 'hr ago')
		}
	}
		adjustPublicationTime();
	},[publishedAt])

	

	return(
		<div className='news-card-container '>
			<a className='news-card-content' href={url} target='_blank' rel='noopener noreferrer'>
					<h2 className='news-card-title'>
						{title}
					</h2>
					<div className='news-card-publication'>
						<div className='news-card-author'>
							{author}
						</div>
						<div className='news-card-publishedAt'>
							{hours}
						</div>
					</div>
			</a>
			<a className='news-card-image-container' href={url} target='_blank' rel='noopener noreferrer'>
				<img className='news-card-image' src={image} alt='newsImage' />
			</a>	
		</div>
		)
}

export default NewsCard